export enum DocumentRetrievalExclusionReason {
    ACCOUNT_CLOSED = "account_closed",
    STATEMENT_UNAVAILABLE = "statement_unavailable",
}

export const DOCUMENT_RETRIEVAL_EXCLUSION_LABELS: Record<
    DocumentRetrievalExclusionReason,
    string
> = {
    [DocumentRetrievalExclusionReason.ACCOUNT_CLOSED]: "Account closed",
    [DocumentRetrievalExclusionReason.STATEMENT_UNAVAILABLE]:
        "Statement unavailable",
};
